import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
declare var Stripe: any;

@Component({
  selector: 'app-buy-credits',
  templateUrl: './buy-credits.component.html',
  styleUrls: ['./buy-credits.component.css']
})
export class BuyCreditsComponent implements OnInit {

	priceList: any = [];

	/*
	{
		amount: 100,
		priceText: "0,79",
		price: 0.79
	}
	*/
	messageCredits: number = 0;
	sidemenuOpen: boolean = true;
	screenHeight: number;
	screenWidth: number;
	productSelection: any = {};
	currentProductAmount: number = 0;
	currentTotalCost: number = 0;
	errorMessage: string = "";
	automaticPaymentErrorMessage: string = "";
	loading: boolean = true;
	progressMessage: string = "";
	purchaseCompleted: boolean = false;
	customAmount: string = "";
	customSelected: boolean = false;
	stripe: any;
	extraFeeNoteHeight: string = "0px";
	extraFeeTreshold: number = 10;
	amountSuggestions: any = [20,50,100,200,500,1000];
	automaticPaymentEnabled: boolean = false;
	automaticPaymentAmount: number = 40;
	automaticPaymentTreshold: number = 20;
	paymentMethods: any = [];
	paymentMethod: string = "";
	automaticPaymentInfoChanged: boolean = false;

	hasBillingInfo: boolean = true;
	billingInfo: any = {};
	changesSaved: boolean = false;
	newUser: boolean = true;
	requiredFields: any = [
		"country",
		"companyName",
		"address",
		"zip",
		"city"
	];

	constructor(public cwsms: CWSMSAPIService, public translate: TranslateService) {
		this.onResize();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth+"x"+this.screenHeight);

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	receivedSideMenuEvent(event) {
		if ("userData" in event) {
			//this.messageCredits = parseFloat(event.userData.credits.N);
			if ("billingInfo" in event.userData) {
				this.newUser = false;
				var bi = event.userData.billingInfo.M;
				for (var key in bi) {
					this.billingInfo[key] = bi[key].S;
				}
			} else {
				this.hasBillingInfo = false;
				this.billingInfo.country = "Norway (Norge)";
			}
			if ("automaticPayment" in event.userData) {
				var obj = event.userData.automaticPayment.M;
				this.automaticPaymentEnabled = obj.enabled.BOOL;
				this.automaticPaymentTreshold = obj.treshold.N;
				this.automaticPaymentAmount = obj.amount.N;
				this.paymentMethod = obj.paymentMethod.S;
			}

			this.cwsms.get("/user/payment-methods", (err, data) => {
				this.loading = false;
				if (err) {
					this.errorMessage = err.error.message;
				} else {
					console.log(data);
					this.paymentMethods = data;

					if (this.paymentMethod.length <= 0) {
						this.paymentMethod = data[0].id;
					}
				}
			});
		}
	}

	setAmount(amnt) {
		this.customAmount = amnt;
		this.changedCustomAmount(amnt);
	}

	changedCustomAmount(val) {
		this.customSelected = true;
		this.selectProduct("custom");
	}

	automaticPaymentContentChanged() {
		this.automaticPaymentInfoChanged = true;
	}

	shouldAddVAT() {
		return "country" in this.billingInfo && this.billingInfo.country.toLowerCase().startsWith("norway");
	}

	getCreditPrice(amount) {
		if (amount < this.extraFeeTreshold) {
			return amount + 0.3;
		}
		return amount;
	}

	getMVAOfCreditPrice() {
		return (this.getCreditPrice(this.currentProductAmount)*0.25).toFixed(2);
	}

	enableAutomaticPayment() {
		this.loading = true;
		setTimeout( () => {
			console.log(this.automaticPaymentEnabled);
			this.savePaymentValues();
		}, 100);
	}

	toggleAutomaticPayment() {
		this.automaticPaymentEnabled = !this.automaticPaymentEnabled;
		this.savePaymentValues();
	}

	savePaymentValues() {
		if (this.paymentMethods.length <= 0) {
			this.loading = false;
			this.automaticPaymentEnabled = false;
			return;
		}

		this.loading = true;
		this.automaticPaymentErrorMessage = "";
		this.cwsms.post("/user/automatic-payment", {
			enabled: this.automaticPaymentEnabled,
			treshold: this.automaticPaymentTreshold,
			amount: this.automaticPaymentAmount,
			paymentMethod: this.paymentMethod
		}, (err, data) => {
			if (err) {
				this.automaticPaymentErrorMessage = err.error.message;
				this.cwsms.get('/user', (err, data) => {
					this.loading = false;
					if (err) {
						this.automaticPaymentErrorMessage = err.error.message;
					} else {
						this.receivedSideMenuEvent({
							userData: data
						});
					}
				});
			} else {
				this.loading = false;
				this.automaticPaymentInfoChanged = false;
			}
		});
	}

	setPaymentMethod(id) {
		this.paymentMethod = id;
		this.automaticPaymentContentChanged();
	}

	selectProduct(amount) {
		if (amount === "custom") {
			this.customSelected = true;
			this.currentProductAmount = parseFloat(this.customAmount);
		} else {
			this.customSelected = false;
			this.currentProductAmount = parseFloat(amount);
		}
		this.errorMessage = "";
		this.currentTotalCost = this.getCreditPrice(this.currentProductAmount);

		if (this.shouldAddVAT()) {
			this.currentTotalCost *= 1.25;
		}

		if (this.currentProductAmount < this.extraFeeTreshold) {
			this.extraFeeNoteHeight = "40px";
		} else {
			this.extraFeeNoteHeight = "0px";
		}
	}

	getTotalCost() {
	}

	purchaseDone() {
		this.purchaseCompleted = false;
		this.loading = false;
		return true;
	}

	confirmCardPayment(intent) {
		this.loading = true;
		this.stripe.confirmCardPayment(intent.client_secret, {
			payment_method: intent.last_payment_error.payment_method.id
		}).then(function(result) {
			this.loading = false;
			if (result.error) {
				// Show error to your customer
				console.log(result.error.message);
			} else {
				if (result.paymentIntent.status === 'succeeded') {
					// The payment is complete!
				}
			}
		});
	}

	buyCredits() {
		this.loading = true;
		this.progressMessage = this.translate.instant("Performing purchase...");
		this.cwsms.post('/user/credits/buy', {
			//stripeToken: result.token.id,
			amount: this.currentProductAmount
		}, (err, data) => {
			if (err) {
				this.loading = false;

				if ("error" in err && "message" in err.error) {
					this.errorMessage = this.translate.instant(err.error.message);
				} else if ("message" in err) {
					this.errorMessage = this.translate.instant(err.message);
				}

				console.log(err);
			} else {
				this.stripe.redirectToCheckout({
					sessionId: data.Attributes.stripeCheckoutSessionID.S
				}).then(function (result) {
					console.log(result);
					if ("error" in result) {
						this.errorMessage = result.error.message;
						this.loading = false;
					}
					// If `redirectToCheckout` fails due to a browser or network
					// error, display the localized error message to your customer
					// using `result.error.message`.
				});
				//console.log(data);
				//this.progressMessage = "Purchase completed!";
				//this.purchaseCompleted = true;
			}
		});
	}

	ngOnInit() {
		/*
		this.loading = true;
		this.cwsms.get('/prices', (err, data) => {
			this.loading = false;
			if (err) {
				this.errorMessage = "Unable to retrieve price list!";
			} else {
				console.log(data);
				this.priceList = data.credits;
			}
		});
		*/

		// Create a Stripe client.
		this.stripe = Stripe(environment.stripeKey);

/*
		// Create an instance of Elements.
		var elements = stripe.elements();

		// Custom styling can be passed to options when creating an Element.
		// (Note that this demo uses a wider set of styles than the guide below.)
		var style = {
		  base: {
		    color: '#000000',
		    lineHeight: '18px',
		    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
		    fontSmoothing: 'antialiased',
		    fontSize: '16px',
		    '::placeholder': {
		      color: '#aab7c4'
		    }
		  },
		  invalid: {
		    color: 'red',
		    iconColor: 'red'
		  }
		};

		// Create an instance of the card Element.
		var card = elements.create('card', {hidePostalCode: true, style: style});

		// Add an instance of the card Element into the `card-element` <div>.
		card.mount('#card-element');

		// Handle real-time validation errors from the card Element.
		card.addEventListener('change', (event) => {
		  var displayError = document.getElementById('card-errors');
		  if (event.error) {
		    displayError.textContent = event.error.message;
		  } else {
		    displayError.textContent = '';
		  }
		  this.errorMessage = "";
		});

		// Handle form submission.
		var form = document.getElementById('payment-form');
		form.addEventListener('submit', (event) => {
			event.preventDefault();

			if (this.currentTotalCost <= 0) {
				this.errorMessage = "No product selected!";
				return;
			}

			this.progressMessage = "Checking card...";

			this.loading = true;
			stripe.createToken(card).then((result) => {
				if (result.error) {
					this.loading = false;
					// Inform the user if there was an error.
					var errorElement = document.getElementById('card-errors');
					errorElement.textContent = result.error.message;
				} else {
					this.progressMessage = "Performing purchase...";
					//console.log(result.token);
					this.cwsms.post('/user/credits/buy', {
						stripeToken: result.token.id,
						amount: this.currentProductAmount
					}, (err, data) => {
						if (err) {
							this.loading = false;

							if ("error" in err && "message" in err.error) {
								this.errorMessage = err.error.message;
							} else if ("message" in err) {
								this.errorMessage = err.message;
							}

							console.log(err);
						} else {
							console.log(data);
							this.progressMessage = "Purchase completed!";
							this.purchaseCompleted = true;
						}
					});
				}
			});
		});*/
	}

	onChangedCountry(country) {
		this.billingInfo.country = country;
	}

	needsBillingInfo() {
		return !this.hasBillingInfo;
	}

	saveChanges() {
		this.changesSaved = false;
		console.log(this.billingInfo);

		var approved = true;
		for (var field of this.requiredFields) {
			if (!(field in this.billingInfo) || this.billingInfo[field].length <= 0) {
				approved = false;
				break;
			}
		}

		if (!approved) {
			this.errorMessage = "You need to fill in all the required fields before saving the changes.";
		} else {
			this.errorMessage = "";

			console.log("Saving billing info...");
			this.loading = true;
			this.cwsms.post('/user/billing-info', {billingInfo: this.billingInfo}, (err, data) => {
				this.loading = false;
				if (err) {
					this.errorMessage = err.message;
				} else {
					this.changesSaved = true;
					this.hasBillingInfo = true;
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/buy-credits/buy-credits.component.ts